import React from 'react';
import { Link } from 'react-router-dom';
import "./Button57.css";

const Button57 = ({ 
  text = "Button 57", 
  altText = "Alternate text", 
  to, 
  href, 
  className = "", 
  variant = "gold", // 'gold' or 'light'
  type = "button",
  onClick,
  ...props 
}) => {
  const content = (
    <>
      <span className="text">{text}</span>
      <span>{altText}</span>
    </>
  );

  const variantClass = variant === 'light' ? 'btn-light' : '';
  const commonProps = {
    className: `button-57 ${variantClass} ${className}`,
    role: "button",
    ...props
  };

  if (to) {
    return (
      <Link to={to} {...commonProps}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} {...commonProps}>
        {content}
      </a>
    );
  }

  return (
    <button type={type} onClick={onClick} {...commonProps}>
      {content}
    </button>
  );
};

export default Button57;